import { useCallback } from 'react';

import useColor from '@/hooks/domain/useColor';
import { useToast } from '@/stores/pure/ToastStore';

import {
  copySVGToClipboard,
  downloadPNG,
  getSVGElement,
} from '../utils/svgUtils';

export const useWordCloudAction = () => {
  const toast = useToast();
  const color = useColor();

  const handleCopyToClipboard = useCallback(
    async (wordCloudId: string) => {
      const wordCloudWrapper = document.querySelector(
        `[data-wordcloud-id="${wordCloudId}"]`,
      ) as HTMLElement;
      if (!wordCloudWrapper) return;

      try {
        const svgElement = getSVGElement(wordCloudWrapper);
        if (svgElement) {
          await copySVGToClipboard(svgElement, {
            width: wordCloudWrapper.clientWidth,
            height: wordCloudWrapper.clientHeight,
            backgroundColor: color.gray100,
          });
          toast('Copied to clipboard successfully');
        }
      } catch (error) {
        toast('Failed to copy to clipboard', 'fail');
      }
    },
    [toast, color.gray100],
  );

  const handleDownloadPNG = useCallback(
    async (wordCloudId: string) => {
      const wordCloudWrapper = document.querySelector(
        `[data-wordcloud-id="${wordCloudId}"]`,
      ) as HTMLElement;
      if (!wordCloudWrapper) return;

      try {
        const svgElement = getSVGElement(wordCloudWrapper);
        if (svgElement) {
          await downloadPNG(svgElement, 'wordcloud.png', {
            width: wordCloudWrapper.clientWidth,
            height: wordCloudWrapper.clientHeight,
            backgroundColor: color.gray100,
          });
          toast('PNG downloaded successfully');
        }
      } catch (error) {
        toast('Failed to download PNG', 'fail');
      }
    },
    [toast, color.gray100],
  );

  return {
    handleCopyToClipboard,
    handleDownloadPNG,
  };
};
